/** Query param that opens Sage on the shared (This record) thread. */
export const SAGE_DEEP_LINK_PARAM = 'sage'
export const SAGE_DEEP_LINK_SHARED = 'shared'

function toSearchParams(search: string): URLSearchParams {
  return new URLSearchParams(search.startsWith('?') ? search.slice(1) : search)
}

export function hasSageSharedDeepLink(search: string): boolean {
  return toSearchParams(search).get(SAGE_DEEP_LINK_PARAM) === SAGE_DEEP_LINK_SHARED
}

/** Absolute URL for the current page with `sage=shared` set. */
export function buildSageSharedDeepLink(
  pathname: string,
  search: string,
  origin: string = typeof window !== 'undefined' ? window.location.origin : ''
): string {
  const params = toSearchParams(search)
  params.set(SAGE_DEEP_LINK_PARAM, SAGE_DEEP_LINK_SHARED)
  const qs = params.toString()
  return `${origin}${pathname}${qs ? `?${qs}` : ''}`
}

/** Remove the Sage deep-link param after it has been consumed. */
export function stripSageDeepLink(search: string): string {
  const params = toSearchParams(search)
  params.delete(SAGE_DEEP_LINK_PARAM)
  const qs = params.toString()
  return qs ? `?${qs}` : ''
}
